import { openAuthModal } from "../../common/authmodal/authmodalservice";

export const SCHEDULE_DRAFT_SAVE_MESSAGE =
  "This will save schedule data. You can update setup, groups, and visits until the schedule is published.";

export const SCHEDULE_DRAFT_UPDATE_MESSAGE =
  "This will update the draft schedule. Changes are audited.";

export const SCHEDULE_LIVE_SAVE_MESSAGE =
  "This will update the live schedule. Changes are audited.";

export const SCHEDULE_LIVE_BANNER =
  "This schedule is live. You can add visits and complete empty setup. Saved visit details cannot be changed or deleted.";

export const SCHEDULE_LIVE_NO_DELETE_MESSAGE =
  "This schedule is live. Visits cannot be deleted.";

export const SCHEDULE_LIVE_NO_REORDER_MESSAGE =
  "This schedule is live. Visit order cannot be changed.";

export const SCHEDULE_LIVE_SAVED_DETAILS_MESSAGE =
  "This schedule is live. Saved visit details cannot be changed.";

export const SCHEDULE_LIVE_NO_DOC_DELETE_MESSAGE =
  "This schedule is live. Documents cannot be deleted.";

export const SCHEDULE_PUBLISH_MIN_READINESS_PERCENT = 100;

export const SCHEDULE_PUBLISH_CONFIRM_MESSAGE =
  "Publishing will make this schedule live. This action cannot be undone.";

export const SCHEDULE_VISIT_DELETE_MESSAGE =
  "This will remove the visit and its setup data from the schedule. This action is audited.";

export const SCHEDULE_VISIT_REORDER_MESSAGE =
  "This will change the visit order in the schedule. This action is audited.";

export const SCHEDULE_LIVE_UPDATE_CONFIRM_MESSAGE =
  "This will update the live schedule. Changes are audited.";

/** Matches backend ESch_AuditInfo.reasonForRevisionRef (nvarchar 500). */
export const SCHEDULE_AUDIT_REASON_MAX_LENGTH = 500;

/**
 * Password + access-code (2FA) with required reason.
 * @returns {Promise<{ ok: true, comments: string } | { ok: false, cancelled?: boolean }>}
 */
export async function authenticateScheduleSave({ showAlert }) {
  const authRes = await openAuthModal({
    showDescription: true,
    requireDescription: true,
    descriptionMaxLength: SCHEDULE_AUDIT_REASON_MAX_LENGTH,
  });

  if (authRes?.Success !== 1) {
    if (!authRes?.cancelled) {
      showAlert?.({
        title: "Authentication required",
        message: "Two-factor authentication failed or was cancelled.",
        type: "warning",
      });
    }
    return { ok: false, cancelled: !!authRes?.cancelled };
  }

  const comments = String(authRes?.Description || "")
    .trim()
    .slice(0, SCHEDULE_AUDIT_REASON_MAX_LENGTH);
  if (!comments) {
    showAlert?.({
      title: "Reason required",
      message: "A reason is required to save schedule data.",
      type: "warning",
    });
    return { ok: false };
  }

  return { ok: true, comments };
}

export function withScheduleComments(payload, comments) {
  if (!comments) return payload;
  return { ...payload, Comments: comments };
}
